export default function Footer() {
  return (
    <footer className="bg-[#f8f5f0] border-t border-gray-200">
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 mb-12">
          {/* Brand */}
          <div className="lg:col-span-1">
            <img
              src="https://static.readdy.ai/image/cd984ab7ba08a0f8b6f75adc7751930e/3d9f8b58849eb5d2771df5fcd23c8990.png"
              alt="RidgeCap GC Logo"
              className="h-16 w-auto object-contain mb-4"
            />
            <p className="text-gray-500 text-sm leading-relaxed mb-4">
              Licensed &amp; insured roofing contractor specializing in insurance claim maximization and manufacturer-certified installations.
            </p>
            <div className="flex items-center gap-3">
              <a
                href="https://www.facebook.com"
                target="_blank"
                rel="nofollow noreferrer"
                className="w-8 h-8 flex items-center justify-center bg-[#1a1a2e] rounded-full cursor-pointer hover:bg-[#f97316] transition-colors"
              >
                <i className="ri-facebook-fill text-white text-sm"></i>
              </a>
              <a
                href="https://www.instagram.com"
                target="_blank"
                rel="nofollow noreferrer"
                className="w-8 h-8 flex items-center justify-center bg-[#1a1a2e] rounded-full cursor-pointer hover:bg-[#f97316] transition-colors"
              >
                <i className="ri-instagram-line text-white text-sm"></i>
              </a>
              <a
                href="https://www.google.com"
                target="_blank"
                rel="nofollow noreferrer"
                className="w-8 h-8 flex items-center justify-center bg-[#1a1a2e] rounded-full cursor-pointer hover:bg-[#f97316] transition-colors"
              >
                <i className="ri-google-fill text-white text-sm"></i>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-[#1a1a2e] font-bold text-sm uppercase tracking-widest mb-5">
              <a href="#depreciation">Quick Links</a>
            </h4>
            <ul className="space-y-3">
              {[
                { label: "Why Depreciation Matters", href: "#depreciation" },
                { label: "Understanding Estimates", href: "#estimates" },
                { label: "Hidden Holdback Funds", href: "#holdback" },
                { label: "Roofing Cost Comparison", href: "#comparison" },
                { label: "Common Cut-Corners", href: "#corners" },
                { label: "How We Help", href: "#help" },
              ].map((link) => (
                <li key={link.label}>
                  <a
                    href={link.href}
                    className="text-gray-500 hover:text-[#f97316] text-sm transition-colors cursor-pointer"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-[#1a1a2e] font-bold text-sm uppercase tracking-widest mb-5">
              <a href="#help">Services</a>
            </h4>
            <ul className="space-y-3">
              {[
                "Insurance Claim Assistance",
                "Residential Roofing",
                "Storm Damage Restoration",
                "Depreciation Recovery",
                "Supplement Filing",
                "Roof Inspection",
              ].map((item) => (
                <li key={item}>
                  <span className="text-gray-500 text-sm">{item}</span>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-[#1a1a2e] font-bold text-sm uppercase tracking-widest mb-5">
              <a href="#cta">Contact</a>
            </h4>
            <ul className="space-y-4">
              <li>
                <div className="text-gray-400 text-xs uppercase tracking-wide mb-1">NWA Office</div>
                <a href="tel:4793964040" className="text-gray-700 font-bold text-sm hover:text-[#f97316] transition-colors cursor-pointer">
                  479-396-4040
                </a>
              </li>
              <li>
                <div className="text-gray-400 text-xs uppercase tracking-wide mb-1">DFW Office</div>
                <a href="tel:2149458899" className="text-gray-700 font-bold text-sm hover:text-[#f97316] transition-colors cursor-pointer">
                  214-945-8899
                </a>
              </li>
              <li>
                <div className="text-gray-400 text-xs uppercase tracking-wide mb-1">Service Areas</div>
                <span className="text-gray-600 text-sm">Northwest Arkansas &bull; Dallas-Fort Worth</span>
              </li>
              <li>
                <a
                  href="#cta"
                  className="inline-flex items-center gap-2 bg-[#f97316] hover:bg-[#ea6c0a] text-white font-bold px-5 py-2.5 rounded-md text-xs whitespace-nowrap cursor-pointer transition-colors duration-200"
                >
                  Free Inspection
                  <i className="ri-arrow-right-line"></i>
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-200 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-gray-400 text-xs">
            &copy; {new Date().getFullYear()} RidgeCap GC. All rights reserved. Licensed &amp; Insured.
          </p>
          <p className="text-gray-400 text-xs">
            Serving Northwest Arkansas &amp; Dallas-Fort Worth
          </p>
        </div>
      </div>
    </footer>
  );
}
